import { Row, Col, Card, Main, Button } from "antd";
import React, { useState, useEffect } from "react";
import useApi from "../../hooks/useApi";
import { useNavigate, useParams } from "react-router-dom";
import { getEmail } from "../../constants/API/API";

function EmailView({ visible }) {
  const [record, setRecord] = useState({});
  const navigate = useNavigate();
  const { id } = useParams();

  const { data } = useApi({
    callback: getEmail,
    payload: id,
    dependencies: [id],
    shouldCallApi: visible,
    onSuccess: (data) => {
      setRecord(data);
    },
  });

  return (
    <>
      <Row gutter={[24, 24]}>
        <Col span={24}>
          <Card title="email details">
            <div className="view-main-list">
              <div className="view-inner-cls">
                <h5>Title:</h5>
                <h6>{record ? record.name : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Subject:</h5>
                <h6>{record ? record.subject : "--"}</h6>
              </div>
              <div className="view-inner-cls">
                <h5>Status </h5>
                <h6>
                  {record ? (record.isActive ? "Active" : "Inactive") : "--"}
                </h6>
              </div>
            </div>
          </Card>
        </Col>

        <Col span={24}>
          <Card>
            <div className="view-main-list">
              <h6>Description :</h6>
              <h5
                dangerouslySetInnerHTML={{
                  __html: record ? record.description : "--",
                }}
              ></h5>
            </div>
          </Card>
        </Col>
        <div className="main-new-declare">
          <Button
            type="primary"
            className="back-button"
            onClick={() => navigate(-1)}
            style={{ margin: 0 }}
          >
            Back
          </Button>
        </div>
      </Row>
    </>
  );
}

export default EmailView;
